import * as React from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ChevronIcon } from '@icons';
import { getBrandFaqSection } from '@utils/get-brand-faq.ts';

import { getFaqData } from '@entities/faq/get-faq-data.ts';

import * as Styled from './faq.styled.ts';

interface OpenItemsState {
	[key: number]: boolean;
}
type FaqProps = {
	isHelpSectionVisible?: boolean;
};

const Faq = ({ isHelpSectionVisible = true }: FaqProps) => {
	const [openItems, setOpenItems] = React.useState<OpenItemsState>({});

	const { t } = useTranslation('faq');

	const { hash } = useLocation();

	React.useEffect(() => {
		if (hash) {
			setTimeout(() => {
				const element = document.querySelector(hash);
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' });
					setOpenItems(prevState => ({
						...prevState,
						[hash.slice(-1)]: true
					}));
				}
			}, 5);
		}
	}, [hash]);

	const faqData = getFaqData(t);
	const faqSection = getBrandFaqSection() as keyof ReturnType<typeof getFaqData>;

	const toggleAccordion = (id: number) => {
		setOpenItems((prevState: Record<number, boolean>) => ({
			...prevState,
			[id]: !prevState[id]
		}));
	};

	return (
		<Styled.Container>
			{faqData[faqSection]
				.filter(item => (!isHelpSectionVisible ? item.id !== 9 : true))
				.map(item => (
					<Styled.Item key={item.id} id={item.anchor}>
						<Styled.Question onClick={() => toggleAccordion(item.id)}>
							<Styled.QuestionTitle>{item.question}</Styled.QuestionTitle>
							<Styled.Arrow $isOpen={openItems[item.id]}>
								<ChevronIcon />
							</Styled.Arrow>
						</Styled.Question>

						{Boolean(item.answer) && (
							<Styled.Answer
								$isOpen={openItems[item.id]}
								dangerouslySetInnerHTML={{ __html: item.answer }}
							></Styled.Answer>
						)}
					</Styled.Item>
				))}
		</Styled.Container>
	);
};

export default Faq;
